import { Real } from "./real.model";
import { Service } from "./service.model";
import { Activity } from "./activity.model";
import { User } from "./user.model";
import { Interval } from './interval.model';
import { Booking } from './booking.model';


import { environment } from "src/environments/environment";

import * as moment from 'moment';
import 'moment-timezone';
moment.tz.setDefault("Europe/Ljubljana");

export class Event {
  public id: string;
  public name: string;
  public start: string;
  public updated: string;
  public venueText: string;
  public end: string;
  public attendeesMin: number;
  public attendeesMax: number;
  public location: Real;
  public service: Service;
  public activity: Activity;
  public status: number;
  public edit: boolean = false;
  public spots: number;

  public confirmed: boolean;
  public confirmedDt: boolean;
  public confirmedUser: User;


  public canceled: boolean;
  public canceledDt: boolean;
  public canceledUser: User;

  public rescheduled: boolean;
  public rescheduledDt: boolean;
  public rescheduledUser: User;

  public bookings: Booking[];


  public _self: string;
  
  public regularPrice1: number;

  private _providerId: string;

  public totalAttendees: number = 0;

  public get providerId(): string {
    return this._providerId;
  }
  public set providerId(value: string) {
    this._providerId = value;
  }

  public multiDay: boolean = false;

  public get statusString(): string {
    switch (String(this.status)) {
      case '-20':
      return 'Ni prišel!';
      case '-10':
      return 'Odpovedana';
      case '10':
      return 'Ni še potrjena!';
      case '20':
      return 'Rezervirano';
      case '30':
      return 'Prišel';
      case '40':
      return 'Poseden';
      case '50':
      return 'Odšel';
      default:
      return 'Neznan';
    }
  }

  public get statusColor(): string {
    switch (String(this.status)) {
      case '-20':
      return 'danger';
      case '-10':
      return 'danger';
      case '10':
      return 'warning';
      case '20':
      return 'warning';
      case '30':
      return 'success';
      case '40':
      return 'success';
      case '50':
      return 'success';
      default:
      return 'medium';
    }
  }

  constructor(obj?: any) {
    this.id = obj && obj.id || null;
    this.name = obj && obj.name || null;
    this.updated = obj && obj.updated || null;
    this.venueText = obj && obj.venueText || null;

    this.regularPrice1 = obj && obj.regularPrice1 || null;


    if ( obj && obj.start ) {
      //convert timezone format - api +200 vs ionic +2:00
      this.start = moment(obj.start).format();
    } 

    if ( obj && obj.end ) {
      //convert timezone format - api +200 vs ionic +2:00
      this.end = moment( obj.end ).format();

      if ( this.id == '195' &&  !this.isMultiDay() ) {
        this.end = moment( obj.end ).add(1, 'days').format();
      }
    }

    /*if (moment(this.start).isBefore(moment())) {
      // If start time is in the past, set it to tomorrow
      this.start = moment().add(1, 'days').format();
      this.end = moment(this.start).add(1, 'hour').format();
    }*/

    // Remove original end check since we handle it above
    /*if (obj && obj.start) {
      this.start = moment( obj.start ).format();
    }*/

    this.attendeesMin = obj && obj.attendeesMin || null;
    this.attendeesMax = obj && obj.attendeesMax || null;
    this.service = obj && obj.service || null;
    this.providerId = obj && obj.providerId || null;
    this.status = obj && obj.status || null;
    this.spots = obj && obj.spots || 0;

    this.confirmed = obj && obj.confirmed || null;
    this.confirmedDt = obj && obj.confirmedDt || null;

    if ( obj && obj.confirmedUser ) {
      this.confirmedUser = ( obj.confirmedUser instanceof User ) ? obj.confirmedUser : new User( obj.confirmedUser );
    }
    

    this.canceled = obj && obj.canceled || null;
    this.canceledDt = obj && obj.canceledDt || null;

    if ( obj && obj.canceledUser ) {
      this.canceledUser = ( obj.canceledUser instanceof User ) ? obj.canceledUser : new User( obj.canceledUser );
    }

    this.rescheduledDt = obj && obj.rescheduledDt || null;

    if ( obj && obj.rescheduledUser ) {
      this.rescheduledUser = ( obj.rescheduledUser instanceof User ) ? obj.rescheduledUser : new User( obj.rescheduledUser );
    }

    if ( obj && obj.location ) {
      this.location = ( obj.location instanceof Real ) ? obj.location : new Real( obj.location );
    }

    if ( obj && obj.service ) {
      this.activity = ( obj.service instanceof Activity ) ? obj.service : new Activity( obj.service );
      this.service = ( obj.service instanceof Service ) ? obj.service : new Service( obj.service );
    }

    this.edit = obj && obj.edit || false;

    if ( obj && obj.bookings   ) {
       
       this.bookings = [];
       
       for (let b of obj.bookings ) {

         if ( b instanceof Booking ) {
           this.bookings.push( b );
         } else {
           this.bookings.push( new Booking( b ) );
         }

       }
    }

    this.calculateTotalAttendees();

    if ( obj && obj._self ) {
      this._self = obj._self;

    } else if ( obj && obj._links && obj._links.self && obj._links.self.href ) {
      this._self = obj._links.self.href;
    }

    this.multiDay = this.isMultiDay();

  }

  calculateTotalAttendees()   {

    if (!this.bookings) {
      return false;
    }
 
    for (let b of this.bookings ) {
      if ( !b.canceled ){
        this.totalAttendees += b.partySize;
      }
    }

  }

  getStartTime() {
    return moment(this.start).format('H:mm');
  }

  getInterval() {
    return new Interval( this.start, this.end );
  }


  setDefaultStartEnd( durationInSeconds = null, start = null, end = null ) {

    if ( start ) {
      this.start = start;

      if ( end ) {
        this.end = end; 
      }

    } else {

      this.start = moment()
        .add(14, 'days') // Add 7 days
        .hour(17)       // Set hour to 17 (5 PM)
        .minute(0)      // Ensure minutes are 0
        .second(0)      // Ensure seconds are 0
        .format();      // Format the date as an ISO string

    }

    if ( !this.end ) {

      let duration = ( durationInSeconds ) ? Math.ceil( durationInSeconds / 60 ): 60;

      this.end = moment( this.start ).add( duration, 'minutes').format();

    }

  }

  isMultiDay(): boolean {

    if (!this.start || !this.end) {
      return false;
    }

    // Use moment's 'isSame' method to compare the dates, ignoring the time.
    // This is more explicit and consistent with the rest of your class.
    return !moment(this.start).isSame(this.end, 'day');
  }
  
}